import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'load-cube',
  templateUrl: './load-cube.component.html',
  styleUrls: ['./load-cube.component.scss']
})
export class LoadCubeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
